<div class="vertical-container">
    <h1 style="font: 600 28px 'Poppins', sans-serif; max-width: 500px; text-align: center;">We have good news for everyone
    </h1>
    <br>
    <br>
    <div class="opportunities-container vertical-container">
        <div *ngFor="let opportunity of opportunities" class="opportunity-container horizontal-container">
            <img [src]="opportunity.illustration" />
            <span style="width: 64px; height: 64px;"></span>
            <div class="opportunity-info-container">
                <h1>{{ opportunity.title }}</h1>
                <br>
                <p>{{ opportunity.about }}</p>
                <div class="actions-container">
                    <i class="fab fa-app-store-ios"></i>
                    <i class="fab fa-google-play"></i>
                </div>
            </div>
        </div>
    </div>
</div>